import styles from './WarningLabel.css'

const WarningLabel = ({content, type, link, recepie, ...props}) => {
  return <div className={`${recepie ? 'mt-10px' : ''} ${styles['wrapper']}`}>
    <i className={type === 'info' ? `fa fa-exclamation-circle ${styles.circle}` : `fa fa-lock ${styles.lock}`} />
    {!link && <label className={`${styles.content}`}>{content}</label>}
    {link && <label className={`${styles.content}`}>{props.children}</label>}
  </div>
}

export default WarningLabel



// WEBPACK FOOTER //
// ./app/pages/Library/Item/ItemDetail/ItemForm/WarningLabel/WarningLabel.js